/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext } from 'react';
import './certification.scss';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import ControlledSwitches from '../../Components/Switch/switch';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import { certificationList } from '../../Api/request/certification';
import UseAxios from '../../Api/http/http';
import EnableDisableCertifiDialog from './enableDisableCertificationDialog'; // Import the renamed dialog component
import {
  handleDialogSubmit,
  handleDialogClose,
} from './enableDisableCertificationDialogUtils';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import {
  ADD_EDIT_RESPONSE_MESSAGES,
  DOWNLOAD,
  CERTIFICATION_MASTER,
  CERTIFICATION_FIELD,
  CERTIFICATION_HEADERNAME,
} from '../../Constants/strings';
import { AuthContext } from '../../Contexts/AuthContext';
import AddCertificationForm from './addeditcertification.js';
import {
  getCertificationsDataPdf,
  getCertificationsDataExcel,
} from '../../Api/request/reports';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { fetchCertificationCategoryList } from './cerficationMasterUtils.js';
import { MODULE_NAMES } from '../../Constants/modules.js';

const CertificationMaster = () => {
  const [rows, setRows] = useState([]);
  const [selectedCertification, setSelectedCertification] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const { userProfile } = useContext(AuthContext);
  const [addCertificationModel, setAddCertificationModel] = useState(false);
  const [editCertificationModel, setEditCertificationModel] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackBarCss, setSnackBarCss] = useState('');
  const [isPdfHovered, setIsPdfHovered] = useState(false);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [certificationId, setCertificationId] = useState([]);
  const [certificationProvider, setCertificationProvider] = useState([]);
  const [certificationName, setCertificationName] = useState([]);
  const [certificationValidity, setCertificationValidity] = useState([]);
  const [certificationProviderValue, setCertificationProviderValue] = useState(
    [],
  );
  const [isEdit, setIsEdit] = useState(false);
  const [categoryName, setCategoryName] = useState(null);
  const [subCategoryName, setSubCategoryName] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_TRAINING_CERTIFICATION] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const getCertificationsData = () => {
    // Fetch certifications list using API

    UseAxios(certificationList())
      .then((response) => {
        const certifications = response.data.certificationDetails.map(
          (certification) => ({
            ...certification,
            id: certification.certificationId,
            providerId: certification.providerId || '-',
          }),
        );

        setRows(certifications);
      })
      .catch(() => {
        setRows([]);
      });
  };

  useEffect(() => {
    getCertificationsData();
    checkMobileView();
    fetchCertificationCategoryList().then(setCategoryList);
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1500);
  };

  const updateCertificateList = () => {
    getCertificationsData();
    setSearchText('');
    clearSearchInput();
  };
  const clearSearchInput = () => {
    const searchInput = document.getElementById('certification-search-input');
    if (searchInput) {
      searchInput.value = '';
    }
  };

  const editHandleClickOpen = (
    certficationId,
    providerID,
    certificationNameVal,
    certificationprovider,
    valdityYear,
    categoryNameVal,
    subCategoryNameVal,
    categoryIdVal,
    subCategoryIdVal,
  ) => {
    setEditCertificationModel(true);
    setIsEdit(true);
    setCertificationId(certficationId);
    setCertificationProvider(certificationprovider);
    setCertificationName(certificationNameVal);
    setCertificationValidity(valdityYear);
    setCertificationProviderValue(providerID);
    setCategoryName(categoryNameVal);
    setSubCategoryName(subCategoryNameVal);
    setCategoryId(categoryIdVal);
    setSubCategoryId(subCategoryIdVal);
  };
  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };
  // add download reports
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };
  const handleDownloadPdf = async () => {
    try {
      await getCertificationsDataPdf();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadExcel = async () => {
    try {
      await getCertificationsDataExcel();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const filteredRows
    = searchText.length >= 1
      ? rows.filter((certification) => {
        return (
          certification.certificationCode
            .toLowerCase()
            .includes(searchText)
            || certification.certificationName
              .toLowerCase()
              .includes(searchText)
            || certification.providerId.toLowerCase().includes(searchText)
            || certification.providerName.toLowerCase().includes(searchText)
            || certification.validity.toString().includes(searchText)
            || certification.categoryName.toLowerCase().includes(searchText)
            || certification.subCategoryName.toLowerCase().includes(searchText)
        );
      })
      : rows;

  const handleSwitchChange = (data) => {
    // Actions to be performed after toggling enable/disable switch
    data.last_updated_by = userProfile.user_name;
    setSelectedCertification(data); // Set the selected certification data
    setIsDialogOpen(true); // Open the dialog
    setIsEdit(true);
  };

  const enableDisableCertificationSnackbar = (
    message,
    severityVal,
    cssClassName,
  ) => {
    setSnackBarCss(cssClassName);
    setOpenSnackbar(true);
    setSnackbarMessage(message);
    setSeverity(severityVal);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };
  const width = {
    'certificationCode': {'mobile': 208, 'laptop': 210},
    'providerId': {'mobile': 250, 'laptop': 230},
    'providerName': {'mobile': 389, 'laptop': 190},
    'certificationName': {'mobile': 389, 'laptop': 250},
    'validity': {'mobile': 194, 'laptop': 180},
    'categoryName': {'mobile': 180, 'laptop': 170},
    'subCategoryName': {'mobile': 180, 'laptop': 190},

  };


  const columns = [
    {
      field: CERTIFICATION_FIELD.CERTIFICATION_ID,
      headerName: CERTIFICATION_HEADERNAME.CERTIFICATION_ID,
      width: width[CERTIFICATION_FIELD.CERTIFICATION_ID ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.15 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_FIELD.PROVIDER_ID,
      headerName: CERTIFICATION_HEADERNAME.PROVIDER_ID,
      width: width[CERTIFICATION_FIELD.PROVIDER_ID ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.17 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_FIELD.PROVIDER_NAME,
      headerName: CERTIFICATION_HEADERNAME.PROVIDER_NAME,
      width: width[CERTIFICATION_FIELD.PROVIDER_NAME ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_FIELD.CERTIFICATION_NAME,
      headerName: CERTIFICATION_HEADERNAME.CERTIFICATION_NAME,
      width: width[CERTIFICATION_FIELD.PROVIDER_NAME ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.16 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_FIELD.VALIDITY,
      headerName: CERTIFICATION_HEADERNAME.VALIDITY,
      width: width[CERTIFICATION_FIELD.VALIDITY ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.125 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        params.value !== null && params.value !== undefined && params.value !== '' ? params.value : 'N/A'
      ),
    },
    {
      field: CERTIFICATION_FIELD.CATEGORY_NAME,
      headerName: CERTIFICATION_HEADERNAME.CATEGORY,
      width: width[CERTIFICATION_FIELD.CATEGORY_NAME ][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.09 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: CERTIFICATION_FIELD.SUB_CATEGORY_NAME,
      headerName: CERTIFICATION_HEADERNAME.SUB_CATEGORY,
      width: width[CERTIFICATION_FIELD.SUB_CATEGORY_NAME][isMobileView && 'mobile' || 'laptop'],
      flex: !isMobileView && !isLaptopView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const mobileColumns = [];
  const desktopColumns = [];

  if (isLaptopView || isMobileView) {
    mobileColumns.push(...columns);
    mobileColumns.push({
      field: 'action',
      headerName: 'Actions',
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: 120,
      flex: !isMobileView && !isLaptopView ? 0.3 : undefined,
      renderCell: (params) => (
        <div className="mobile-action-icons">
          <ControlledSwitches
            disabled={!hasAccess('delete')} // Disable switch based on permission
            checked={Boolean(params.row.isActive)}
            handleChange={() => {
              handleSwitchChange(params.row);
            }}
            inputProps={{ 'aria-label': 'enable/disable' }}
            switchCss="switchCss"
          />
          <button
            disabled={!hasAccess('update')} // Disable edit button based on permission
            id="certificationMaster-edit-button"
            className="certification-action-edit-icon"
            onClick={() =>
              editHandleClickOpen(
                params.row.certificationId,
                params.row.providerId,
                params.row.certificationName,
                params.row.providerName,
                params.row.validity,
                params.row.categoryName,
                params.row.subCategoryName,
                params.row.categoryId,
                params.row.subCategoryId,
              )
            }
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
            }}
          >
            <img
              src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
              alt="Edit"
            />
          </button>
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    });
  } else {
    desktopColumns.push(...columns);
    desktopColumns.push(
      {
        field: CERTIFICATION_FIELD.IS_ACTIVE,
        headerName: CERTIFICATION_HEADERNAME.ENABLE_DISABLE,
        headerClassName: 'enable-disable-column',
        cellClassName: 'enable-disable-cell',
        flex: 0.1,
        renderCell: (params) => (
          <ControlledSwitches
            disabled={!hasAccess('delete')} // Disable switch based on permission
            checked={Boolean(params.value)}
            handleChange={() => {
              handleSwitchChange(params.row);
            }}
            inputProps={{ 'aria-label': 'enable/disable' }}
            switchCss="switchCss"
          />
        ),
        sortable: false,
        disableColumnMenu: true,
      },
      {
        headerName: CERTIFICATION_HEADERNAME.ACTION,
        type: 'number',
        headerClassName: 'action-column',
        cellClassName: 'action-cell',
        flex: 0.06,
        renderCell: (params) => (
          <button
            disabled={!hasAccess('update')} // Disable edit button based on permission
            id="certificationMaster-edit-button"
            className="certification-action-edit-icon"
            onClick={() =>
              editHandleClickOpen(
                params.row.certificationId,
                params.row.providerId,
                params.row.certificationName,
                params.row.providerName,
                params.row.validity,
                params.row.categoryName,
                params.row.subCategoryName,
                params.row.categoryId,
                params.row.subCategoryId,
              )
            }
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
            }}
            aria-label="Edit"
          >
            <img
              src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
              alt="Edit"
            />
            {/* alt attribute is now empty because the button has an aria-label for accessibility */}
          </button>
        ),
        sortable: false,
        disableColumnMenu: true,
      },
    );
  }

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
    columns[5].field,
    columns[6].field,
  ];

  return (
    <div className="cert-master-outer-layer ">
      <div className="certification-master">
        <div className="certification-master-title">{CERTIFICATION_MASTER}</div>
        <div className="certification-search-and-buttons">
          <div className="certification-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="certification-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <div className="certification-button">
            <div className="certification-button-download ">
              <ButtonComponent
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img alt="Arrow Down" src={ArrowDropDown} />}
                btnCss="download-certificate-btn"
              ></ButtonComponent>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="download-certify-dropdown"
                  onMouseEnter={() => setIsPdfHovered(true)}
                  onMouseLeave={() => setIsPdfHovered(false)}
                >
                  <img
                    src={isPdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="download-certify-dropdown"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                >
                  <img
                    src={isExcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
            <div>
              <ButtonComponent
                disabled={!hasAccess('create')} // Disable add button based on permission
                label={CERTIFICATION_HEADERNAME.ADD_CERTIFICATION}
                variant="contained"
                onClick={() => {
                  setAddCertificationModel(true);
                  setIsEdit(false);
                }}
                startIcon={<AddIcon />}
                btnCss={
                  !hasAccess('create')
                    ? 'add-certification-btn-disabled'
                    : 'add-certification-btn'
                }
              ></ButtonComponent>
            </div>
          </div>
        </div>
        <div className="certificate-data-grid-container">
          {filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={isMobileView || isLaptopView ? mobileColumns : desktopColumns}
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
      <div className="button">
        <AddCertificationForm
          modalOpen={addCertificationModel}
          handleClose={() => {
            setAddCertificationModel(false);
          }}
          setRows={updateCertificateList}
          categoryList={categoryList}
          lastUpdatedBy={userProfile.user_name}
        />
        <AddCertificationForm
          modalOpen={editCertificationModel}
          handleClose={() => {
            setEditCertificationModel(false);
            setIsEdit(false);
          }}
          isEditMode={true}
          isEdit={isEdit}
          setRows={setRows}
          editId={certificationId}
          editName={certificationName}
          editProvider={certificationProvider}
          editValidity={certificationValidity}
          editProviderValue={certificationProviderValue}
          categoryList={categoryList}
          editCategoryName={categoryName}
          editSubCategoryName={subCategoryName}
          lastUpdatedBy={userProfile.user_name}
          editCategoryId={categoryId}
          editSubcategoryId={subCategoryId}
        />
      </div>
      {isDialogOpen
        && selectedCertification && ( // Enable/Disable certfication dialog
        <EnableDisableCertifiDialog
          selectedCertification={selectedCertification}
          handleCloseAction={handleDialogClose}
          handleEnableDisableAction={handleDialogSubmit}
          setIsDialogOpen={setIsDialogOpen}
          setRows={setRows}
          handleSnackbar={enableDisableCertificationSnackbar}
          setIsEdit={setIsEdit}
        />
      )}
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={snackBarCss}
      />
    </div>
  );
};

export default CertificationMaster;
